// extracted by mini-css-extract-plugin
module.exports = {"events":"CategoryCascad-module--events--2AdCx","headings":"CategoryCascad-module--headings--xZKdQ","card":"CategoryCascad-module--card--3g8-A"};